import * as Sentry from '@sentry/react';

export const reportMissingIconNameToSentry = (name: string) =>
  Sentry.captureException(
    new Error(`Cannot render Icon with missing name=${name}`),
  );
